var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSendIconColor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_61_44)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.9506 0.943472C22.0006 0.818534 22.0128 0.681666 21.9858 0.549836C21.9587 0.418006 21.8936 0.297012 21.7984 0.201853C21.7033 0.106694 21.5823 0.0415551 21.4504 0.0145124C21.3186 -0.0125304 21.1817 -0.000288013 21.0568 0.0497216L1.05468 8.05085H1.0533L0.431804 8.29835C0.314091 8.3453 0.211647 8.42388 0.135788 8.5254C0.0599298 8.62692 0.0136091 8.74744 0.00194286 8.87363C-0.00972338 8.99983 0.0137189 9.12679 0.0696802 9.2405C0.125642 9.35421 0.211944 9.45023 0.319054 9.51797L0.882804 9.87547L0.884179 9.87822L7.75231 14.248L12.1221 21.1161L12.1248 21.1188L12.4823 21.6826C12.5503 21.7893 12.6463 21.8752 12.76 21.9308C12.8736 21.9864 13.0004 22.0096 13.1263 21.9978C13.2523 21.986 13.3725 21.9396 13.4738 21.8639C13.5751 21.7882 13.6536 21.6859 13.7006 21.5685L21.9506 0.943472ZM19.4302 3.54222L9.12593 13.8465L8.83031 13.3817C8.77614 13.2964 8.70384 13.2241 8.61856 13.17L8.1538 12.8743L18.4581 2.5701L20.0778 1.92247L19.4316 3.54222H19.4302Z",
    fill: "#2A5350"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_61_44"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendIconColor);
export default __webpack_public_path__ + "static/media/send-icon-color.09089a8e4ebda5260fe27ffb0ff21b43.svg";
export { ForwardRef as ReactComponent };